import React from 'react';
import Box from '../Box/Box';
import Control from '../Control/Control';
import styles from './Application.module.css';

const Application = () => {



    return (
        <div className={styles.Application}>
            <Box/>
            <Control/>
        </div>
    )
}

export default Application
